import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { MedicalEventStatus } from '@dreryk/egabinet-visit-frontend-api';

import {
   CheckIcon,
   HourglassBottomIcon,
   HourglassTopIcon,
   NotIcon,
   PatientStatusOptions,
} from '@dreryk/react-components';

const useMedicalEventOptions = (): PatientStatusOptions<Record<MedicalEventStatus, unknown>> => {
   const theme = useTheme();
   return useMemo(
      () => ({
         REGISTERED: {
            icon: <CheckIcon />,
            backgroundColor: theme.success,
         },
         ERROR: {
            icon: <NotIcon />,
            backgroundColor: theme.error,
         },
         PENDING: {
            icon: <HourglassTopIcon />,
            backgroundColor: theme.warning,
         },
         OUTDATED: {
            icon: <HourglassBottomIcon />,
            backgroundColor: theme.error,
         },
      }),
      [theme]
   );
};

export { useMedicalEventOptions };
